// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__T2HGf"};